var exports = {
  "LN": "rightContentWrapper__DE7XPN",
  "dU": "reducedTopPadding__I6AUlR",
  "I6": "constrainedHeader__3mxXgT",
  "N1": "headerContainer__8EHzEz",
  "DD": "title__T_G_Mt",
  "gD": "sidePanelOpen__cL0CWW",
  "A2": "sidePanelOpenUpdatedHeader__GrA8Gi",
  "lj": "actionsAboveTitleOnNarrow__Q6VWPJ",
  "K1": "actionsAboveTitleOnNarrowContainer__3AMR5U",
  "Di": "editTitleFormUpdatedHeader___OLugN",
  "sI": "editTitleFormSidePanelOpen__QcJpH4",
  "Xn": "headerBorderBottom__EGA2X_",
  "Li": "titleWithAction__ouGvRe",
  "Mi": "inlineTitle__2vo_uR",
  "QL": "titleSuffix__ZhvAF5",
  "KT": "squareButton__RQR1K-",
  "rA": "hideWhenTabsOverflow__nvJRNX",
  "DP": "hideWhenVeryNarrowContainer__gKh_VK",
};

module.exports = exports;
